import React from 'react';
import { Badge } from '../ui/index.js';
import { stagePresentation } from '../presentation/stage-presentation.mjs';
export function RequestStatus({ stage, label, className = '', ...props }) {
  const presentation = stagePresentation(stage);
  return <Badge tone={presentation.tone} className={`status status-${String(stage || '').toLowerCase()} ${className}`} data-stage={stage} {...props}><span className="status-dot" aria-hidden="true" />{label || presentation.label}</Badge>;
}
export default RequestStatus;
